import { Locations } from "01Data/02User/Locations";
import { EditUserData, User } from "01Data/Account";
import { appData } from "01Data/AppData";

export class ProcessAccountSettingPage {
  public loginUser: User = new User(null);
  public users: User[] = [];
  public iSelectedUser = -1;
  public edit: EditUserData = { UserId: "" };
  public locations: Locations = new Locations();

  public Clear() {
    this.loginUser = new User(null);
    this.users = [];
    this.iSelectedUser = -1;
    this.edit = { UserId: "" };
  }
  public async Load() {
    const id = await appData.account.GetLoginUserId();
    this.users = await User.GetUsers();
    this.loginUser =
      this.users.find((user: User) => user.UserId === id) ?? new User(null);
    // ログインユーザを取り除く & ソート
    const types = ["administrtaor", "sub_admin", "manager", "user"];
    this.users = this.users
      .filter((user: User) => user.UserId !== this.loginUser.UserId)
      .sort((a, b) => {
        if (a.AccountType === b.AccountType) {
          if (a.family_name === b.family_name) {
            return a.given_name.localeCompare(b.given_name);
          } else {
            return a.family_name.localeCompare(b.family_name);
          }
        } else {
          return types.indexOf(a.AccountType) > types.indexOf(b.AccountType)
            ? 1
            : -1;
        }
      });
    await this.locations.GetLocationData();
  }

  public async Register(data: User) {
    await data.RegisterUser();
    await this.Load();
  }

  public async EditUser() {
    await User.EditUser(this.edit);
    await this.Load();
  }

  public async Delete(data: User) {
    await data.DeleteUser();
    await this.Load();
  }
}
